import Loader from "atoms/loaders/loader";
import { SearchFormSizes } from "molecules/enums/search-form-sizes";
import SearchForm from "molecules/forms/search-form";
import TeamResultsTable from "organisms/modals/support-user-team-manage-modal/modal-phases/find-teams/team-results-table";
import React, { useState } from "react";
import useTeamsAdmin from "utilities/hooks/domain/admin/teams/use-teams-admin";

const CSS_BASE_CLASS = "c-support-user-team-manage-modal";
interface TeamsSearchbarProps {
    selectedTeamId: number | undefined;
    onTeamClick: (teamId: number | undefined) => void;
}
const TeamsSearchbar = (props: TeamsSearchbarProps) => {
    const { onTeamClick, selectedTeamId } = props;
    const [searchText, setSearchText] = useState("");
    const { take, loadTeams, teams, loadingTeams } = useTeamsAdmin();

    const handleSearchTextChanged = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSearchText(e.target.value);
    };

    const handleSearchFormSubmit = async (
        e:
            | React.FormEvent<HTMLFormElement>
            | React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        onTeamClick(undefined);
        await loadTeams({
            searchText,
            take,
        });
    };

    return (
        <div className={`${CSS_BASE_CLASS}__content__controls`}>
            <SearchForm
                onSearchClick={handleSearchFormSubmit}
                onSearchTextChange={handleSearchTextChanged}
                placeholder={"Search by email address or team name"}
                searchText={searchText}
                size={SearchFormSizes.Small}
            />
            {loadingTeams ? (
                <div className={`${CSS_BASE_CLASS}__loader-wrapper`}>
                    <Loader accessibleText={"Loading Teams..."} />
                </div>
            ) : (
                <TeamResultsTable
                    selectedTeamId={selectedTeamId}
                    teams={teams}
                    onTeamClick={onTeamClick}
                />
            )}
        </div>
    );
};

export default TeamsSearchbar;
